import { Link, useLocation } from "react-router-dom";
import style from './Footer.module.css'

export default function Footer() {
    const location = useLocation();
    const hideFooterLinks = ["/login", "/", "/signup"].includes(location.pathname);

    return (
        <>
            {!hideFooterLinks && (
                <footer className="bg-light border-top py-3">
                    <div className="container d-flex justify-content-between align-items-center">
                        <p className={`${style.link} mb-0 text-muted`}>© 2025 PeoplePulse</p>
                        <p className="mb-0">
                            <Link to="/privacy-policy" className={`${style.link} me-3`} style={{ textDecoration: 'none' }}>Privacy </Link>
                            <Link to="/terms-and-conditions" className={style.link} style={{ textDecoration: 'none' }}>Terms  </Link>
                        </p>
                    </div>
                </footer>
            )
            }
        </>
    );
}
